//ags-bet-slider-control-factory.ts
import { FlexiSlider } from "appworks/graphics/elements/flexi-slider";
import { SliderElement } from "appworks/graphics/elements/slider-element";
import { Layers } from "appworks/graphics/layers/layers";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { AgsBetSliderControl } from "../ags-bet-slider-control";

export class AgsBetSliderControlFactory implements ControlFactory {
    /**
     * Determines if the current layer contains the required sprites and FlexiText
     * for AgsBetSliderControl instances.
     * @param layer The Layers instance to check.
     * @returns A boolean indicating if the sprites and FlexiText are present.
     */
    public filter(layer: Layers): boolean {
        return (
            layer.getSprite("bet_amount_slider_track") != null &&
            layer.getSprite("bet_amount_slider_fill") != null &&
            layer.getSprite("bet_amount_slider_handle") != null &&
            layer.getFlexiText("bet_amount_slider_label") != null
        );
    }

    /**
     * Builds AgsBetSliderControl instances based on the current layers.
     * @param layer The Layers instance to use for building the controls.
     * @returns An array of AgsBetSliderControl instances.
     */
    public build(layer: Layers): AgsBetSliderControl[] {
        const sliderElement = new SliderElement(
            layer,
            layer.getSprite("bet_amount_slider_track"),
            layer.getSprite("bet_amount_slider_fill"),
            layer.getSprite("bet_amount_slider_handle")
        );

        const slider = new FlexiSlider();
        slider.addTarget(sliderElement);

        const label = layer.getFlexiText("bet_amount_slider_label");
        const menuBackgroundSprite = layer.getSprite("bet_settings_background");
        const detectionAreaSprite = layer.getSprite("detection_area");

        return [
            new AgsBetSliderControl(slider, label, menuBackgroundSprite, detectionAreaSprite),
        ];
    }
}
